'use client';
import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';
import type {ElementType, ReactNode} from 'react';
import {Typography} from '../primitives';

const LinksRoot = styled(Box, {shouldForwardProp: propName => propName !== 'oDirection'})<{
  component?: ElementType;
  oDirection: 'column' | 'row';
}>(({theme, oDirection}) => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'flex',
  flexDirection: oDirection,
  gap: oDirection === 'row' ? theme.spacing(3) : theme.spacing(2.25),
}));

export function ColumnHeading({children}: {children?: ReactNode}) {
  return (
    <Typography
      size="body-2"
      weight="semiBold"
      mobileSize="body-1"
      mobileWeight="semiBold"
      as="h3"
      sx={{textTransform: {xs: 'none', md: 'capitalize'}, color: theme => theme.palette.colors.text.neutral.inverse, mb: 1.75}}
    >
      {children}
    </Typography>
  );
}

ColumnHeading.displayName = 'ColumnHeading';

export function ColumnLinks({
  component,
  direction = 'column',
  children,
}: {
  component?: ElementType;
  direction?: 'column' | 'row';
  children?: ReactNode;
}) {
  return (
    <LinksRoot component={component} oDirection={direction}>
      {children}
    </LinksRoot>
  );
}

ColumnLinks.displayName = 'ColumnLinks';
